module.exports = __webpack_public_path__ + "img/pos (2).d0650d5f.png";